export const base = {
  fonts: {
    fontHeavy: "Avenir-Heavy",
    fontMedium: "Avenir-Medium",
  },
};

export const  breakpoints = {
  xs: "(min-width: 320px)",
  small: "(min-width: 375px)",
  smallMedium: "(min-width: 650px)",
  medium: "(min-width: 768px)",
  large: "(min-width: 920px)",
  larger: "(min-width: 1024px)",
  xl: "(min-width: 1224px)",
  xl2: "(min-width: 1350px)",
  xl3: "(min-width: 1500px)",
  xl4: "(min-width: 1700px)",
  xl5: "(min-width: 1920px)",
  xl6: "(min-width: 2160px)",
  xl7: "(min-width: 2560px)",
}

export const baseColors = {
  backgroundLight: "#fffff8",
  backgroundDark: "#f2f0e6",
  textDark: "#262624",
  textWhite: "#fff",
  orange: "#fbaa2e",
};

export const primaryColors = {
  purple: "#97459a",
  teal: "#00a89d",
  red: "#f05931",
};

export const purple = {
  ...baseColors,
  primary: primaryColors.purple,
};

export const teal = {
  ...baseColors,
  primary: primaryColors.teal,
};

export const red = {
  ...baseColors,
  primary: primaryColors.red,
};
